import { Spinner } from '@change/ds-core-ui';

import { withPrefetchedData } from 'src/shared/prefetch';

import { PetitionGuidesPageContextProvider, prefetchPageContext } from 'src/app/pages/petitionGuides/pageContext';
import type { PetitionGuidesPagePrefetchedDataProps } from 'src/app/pages/petitionGuides/pageContext';

import { Layout } from '../layout';

import { PetitionGuidesErrorHandler } from './ErrorHandler';

export const PetitionGuidesLandingPage = withPrefetchedData(
	function PetitionGuides({ prefetchedData }: PetitionGuidesPagePrefetchedDataProps) {
		return (
			<PetitionGuidesPageContextProvider
				prefetchedData={prefetchedData}
				errorHandler={PetitionGuidesErrorHandler}
				loadingFallback={<Spinner className="mx-auto my-64" />}
			>
				<Layout />
			</PetitionGuidesPageContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,

		prefetchData: async (context) => prefetchPageContext(context),
	},
);
